import React, { useState, useEffect } from 'react';
import './HomeNavbar.css';
import { NavHashLink } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import myData from '../../../utils/myData';

const HomeNavbar = () => {
    // const resumeLink = `https://drive.google.com/file/d/1hRu7Z3eG8N-e1z6X2EH304wels3wKL3B/view?usp=sharing`
    const resumeLink = myData?.resumeLink || ""
    // const [menuDist,setMenuDist] = useState(0)
    const [width,setWidth] = useState(window.innerWidth);
    const [isOpen,setIsOpen] = useState(true);

    const functionResize= () =>{
        let windowWidth = window.innerWidth;
        if(windowWidth>667){
            if(width>667){
                return
            }
            else{
                setWidth(windowWidth)
            }
        }
        else{
            if(width<667){
                return
            }
            else{
                setWidth(windowWidth)
            }
        }
    }
    window.onresize = ()=>functionResize();

    useEffect(() => {
        const menuBtn = document.getElementById('menu-toggle-btn');
        const menu= document.getElementById('menu-holder');
        if(width<667){
            console.log('toggle');
            menuBtn.style.display="block";
            menu.style.display="none";
            menu.classList.add('home-navbar-toggle-container')
            menu.classList.remove('home-navbar-open-container')
        }
        else{
            setIsOpen(true)
            console.log('no')
            menuBtn.style.display="none";
            menu.style.display='flex';
            menu.classList.add('home-navbar-open-container')
            menu.classList.remove('home-navbar-toggle-container')
        }
    },[width]);
    
    
    
    const handleOnClick = () =>{
        const menu= document.getElementById('menu-holder');
        setIsOpen(!isOpen);
        if(isOpen){
            menu.style.display='block';
        }
        else{
            menu.style.display='none';
        }
    }

    const handleNavClick = () => {
        if(width>667){
            return
        }
        const menu= document.getElementById('menu-holder');
        menu.style.display='none';
        setIsOpen(true);
    }

    
    return (
        <div className="home-navbar-main-container">
            <div>
                <div className="menu-toggle-btn-container">
                    <a className='nav-resume-btn' onClick={handleNavClick} href={resumeLink} target="_blank" rel="noreferrer">Resume</a>
                    <button id="menu-toggle-btn" onClick={handleOnClick}>
                    {isOpen?<FontAwesomeIcon  icon={faBars} />:<FontAwesomeIcon  icon={faTimes} />}
                </button>
                </div>
            </div>
            <div id="menu-holder" className="home-navbar-open-container home-navbar-toggle-container">
                <ul>
                    <li>
                        <NavHashLink onClick={handleNavClick} to="/home">Home</NavHashLink>
                    </li>
                    <li>
                        <NavHashLink onClick={handleNavClick} to="/home#home-about">About</NavHashLink>
                    </li>
                    <li>
                        <NavHashLink onClick={handleNavClick} to="/home#home-project">Projects</NavHashLink>
                    </li>
                    <li>
                        <NavHashLink onClick={handleNavClick} to="/blogs">Blogs</NavHashLink>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default HomeNavbar;